module.exports = __webpack_public_path__ + "img/serifnew_box14.6834367a.jpg";